import React, {useEffect, useRef} from 'react';
import {
    Box,
    Typography,
    CircularProgress,
    Alert
} from '@mui/material';

import useSharePointPdf from '../../hooks/useSharePointPdf';

const loadingContainerStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    gap: 2
};

export default function ContentViewPanel({clickedPdfUrl, clickedPdfName, isResizing, entraAuthentication}) {
    const {
        initialized,
        account,
        interactionInProgress,
        error: authError,
        acquireToken
    } = entraAuthentication;

    const {
        pdfUrl,
        loading: pdfLoading,
        error: pdfError,
        currentPdfUrl,
        fetchPdfFromUrl,
        setPdfClickUrl
    } = useSharePointPdf(acquireToken);

    const lastFetchedUrlRef = useRef(null);

    useEffect(() => {
        if (clickedPdfUrl) {
            lastFetchedUrlRef.current = null;
            setPdfClickUrl(clickedPdfUrl);
        }
    }, [clickedPdfUrl, clickedPdfName, setPdfClickUrl]);

    useEffect(() => {
        if (account && initialized && !pdfLoading && currentPdfUrl && clickedPdfUrl &&
            currentPdfUrl === clickedPdfUrl && lastFetchedUrlRef.current !== currentPdfUrl) {
            lastFetchedUrlRef.current = currentPdfUrl;
            const timeoutId = setTimeout(() => {
                fetchPdfFromUrl(currentPdfUrl);
            }, 10);

            return () => clearTimeout(timeoutId);
        }
    }, [account, initialized, currentPdfUrl, clickedPdfUrl, pdfLoading, fetchPdfFromUrl]);

    const error = authError || pdfError;

    if (!initialized || (interactionInProgress && !account)) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" sx={{height: '100%'}}>
                <CircularProgress size={24}/>
                <Typography sx={{ml: '0.125rem'}}>
                    {!initialized ? 'Initializing...' : 'Signing in...'}
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{height: '100%', display: 'flex', flexDirection: 'column'}}>
            <Box sx={{flex: 1, overflow: 'hidden'}}>
                {pdfLoading ? (
                    <Box sx={loadingContainerStyle}>
                        <CircularProgress size={48}/>
                        <Typography variant="h6">Loading PDF...</Typography>
                    </Box>
                ) : error ? (
                    <Alert severity="error" sx={{m: '0.125rem'}}>
                        {error}
                    </Alert>
                ) : pdfUrl && (
                    <iframe
                        title="SharePoint Content Document"
                        src={pdfUrl}
                        width="100%"
                        height="100%"
                        style={{border: "none", pointerEvents: isResizing ? "none" : "auto"}}/>
                )}
            </Box>
        </Box>
    );
}